import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DailyReport, DailyReportColControl, DailyReportColEnum, DailyReportHideColEnum, DailyReportIcodeSum, DailyReportItem } from 'src/app/payments/models/daily-report';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { HcrService } from 'src/app/services/hcr-service.service';
import { LocalPrintService } from 'src/app/services/local-print.service';
import { UserCache } from 'src/app/services/user-cache';
import { WebApiClient } from 'src/app/services/web-api-client.service';
import { WebApiService } from 'src/app/services/web-api.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { NullOrEmpty, NullOrEmptyTrim } from 'src/app/shared/utilities';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { PRN001Params } from 'src/app/services/api-service/parameters/PRN001Params';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-daily-payment-report',
  templateUrl: './daily-payment-report.component.html',
  styleUrls: ['./daily-payment-report.component.css']
})
export class DailyPaymentReportComponent implements OnInit, AfterViewInit {

  sizePage = {
    width: 20, //cm
    height: 28.5 //cm
  };

  paddingPage = {
    top: 0, // cm
    right: 0, // cm
    bottom: 0.2, // cm
    left: 0 // cm
  };

  heightPageWithoutPadding = this.convertCmtoPx(
    this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom)
  );

  printParams: DailyReportPrintParaMeter = {
    Type: 1,
    PaperSize: 'A4',
    AdjustHeight: 0.5,
    PagePaddingTop: 0.3,
    PagePaddingBottom: 0.3,
    PagePaddingRight: 0,
    PagePaddingLeft: 0,
    PageWidth: 20.6,
    PageHeight: 29,
    InitFontSize: 10,
    InitRow: 57
  };

  // heightPageWithoutPadding = this.convertCmtoPx(
  //     this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom) +0.5
  // );
  elContainer;
  anchorsBlockValue;
  pageContent = [[]];     // Ex: [[0, 1, 2, 3], [4, 5]]

  @ViewChild('reportContainer', { static: false })
  reportContainer: ElementRef<HTMLDivElement>;
  @ViewChildren('[doRemark]') elementsWithReport: QueryList<ElementRef>;
  @ViewChildren('[doExcel]') elementsWithExcel: QueryList<ElementRef>;

  showDoctorNameColume: boolean;
  monthStr: string = '';
  nowStr: string = '';
  condStr: string = '';
  reportTime: Date;
  totalRecord: number = 0;
  pageNo: number = 1;
  _sDate: Date;
  _eDate: Date;
  dailyReport: DailyReport;
  // 清單物件
  listItems: DailyReportItem[] = [];
  listIcodeSum: DailyReportIcodeSum[] = [];
  // api服務
  api: WebApiService;
  // 查詢條件;
  queryFormGroup: FormGroup;
  dailyReportShowPayment: boolean = false;
  prn001: PRN001Params;
  //hst001 : HST001Params;
  isInJail: boolean = false;
  columnLine = 0;
  queryRptType = '';

  enumArray = DailyReportColEnum;
  hidecolArray: string[] = [];
  allColumns: string[] = [];
  fontsize = 10;
  fontRange = 1;
  forExcel = true;
  coladd = 1;
  constructor(private webApiClient: WebApiClient,
    private localPrintService: LocalPrintService,
    private notification: EasyNotificationService,
    private hcrService: HcrService,
    private clinicData: ClinicDataService,
    private sessionService: SessionService,
    private elementRef: ElementRef) {
    this.api = this.webApiClient.createHisService('Payments/Payment');
  }
  @Input() isHomeCare = false;

  async ngOnInit() {
  }
  async ngAfterViewInit() {
    this.prn001 = await this.clinicData.getParam("PRN001");
    this.dailyReportShowPayment = this.prn001?.DailyReportShowPayment;

    if (this.prn001.DailyReportType == 2) {
      // 參數設定為2時則為橫向大小
      this.printParams = {
        Type: 2,
        PaperSize: 'A4 landscape',
        AdjustHeight: 0,
        PagePaddingTop: 0.3,
        PagePaddingBottom: 0.3,
        PagePaddingRight: 0.2,
        PagePaddingLeft: 0.2,
        PageHeight: 20,
        PageWidth: 28.5,
        InitFontSize: 10,
        InitRow: 40
      };

      this.heightPageWithoutPadding = this.convertCmtoPx(
        this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom)
      ) - 350;
      this.sizePage.height = 20;
      this.sizePage.width = 28.5;
    }

    let marginSize = this.dailyReportShowPayment ? 0 : 0.5;
    var st = document.createElement('style');
    st.appendChild(document.createTextNode(
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.pres-report2 table{ border:0px solid black; }\n' +
      '.pres-report2 table td, table th { border-bottom: 1px solid black; padding-left: 0.1px;padding-right: 0.1px;}\n' +
      '.pres-report2 table tr:first-child th { border-top: 0; vertical-align: bottom; padding: 0px }\n' +
      '.pres-report2 table tr:last-child td { border-bottom: 0; }\n' +
      '.pres-report2 table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
      '.pres-report2 table tr td:last-child, table tr th:last-child { border-right: 0; }\n' +
      `@page { size: ${this.printParams.PaperSize}; margin: 0.5cm 0.5cm; }\n`
      // `@page { size: ${this.printParams.PaperSize}; margin: ${marginSize}cm ${marginSize}cm; }\n`
      // '#pageHeader:after { counter-increment: page; content: counter(page); }\n'
    ));

    setTimeout(() => {
      this.reportContainer.nativeElement.appendChild(st);
    }, 0);

  }
  // 取得統計期間的看診人次資料，並組出報表的html內容
  async fetchData(query: any, allColumns: DailyReportColControl[]) {
    this.allColumns = allColumns.map(x => x.Col);

    this.elContainer = document.getElementById("container");
    this.dailyReport = new DailyReport();

    //this.hst001 = await this.clinicData.getParam("HST001");
    this.isInJail = this.sessionService.getData('useOutVisitJail');
    let hidecolnums = this.prn001?.DailyReportHideCol?.length > 0 ? this.prn001.DailyReportHideCol.split(',')
      .filter(item => !isNaN(Number(item)))  // 過濾掉非數字的子字符串
      .map(item => Number(item)) : [];

    if (query.reportType == 'summary') hidecolnums = hidecolnums.concat([2, 3, 4, 5, 6, 7, 8, 9, 10])

    this.queryRptType = query.reportType;
    this.hidecolArray = DailyReportHideColEnum
      .filter(item => hidecolnums.includes(item.Seq))  // 過濾出序列包含的項目
      .map(item => item.Col);
    const hide = DailyReportHideColEnum.filter(item => hidecolnums.includes(item.Seq))
      .map(item => item.Witdh).reduce((sum, number) => sum + number, 0);
    const totalWidth = allColumns.reduce((sum, column) => sum + column.Witdh, 0) + 15;
    this.fontRange = totalWidth / (totalWidth - hide) <= 1.5 ? totalWidth / (totalWidth - hide) : 1.5;

    this._sDate = query.startDate;
    this._eDate = query.endDate;

    // 條件顯示文字
    if (query.conditionDisplayText && query.conditionDisplayText.trim() !== '') {
      this.condStr = '篩選條件: ' + query.conditionDisplayText;
    } else {
      this.condStr = '';
    }

    this.api.post('GetDailyReport', query).subscribe(
      (data: DailyReport) => {
        this.dailyReport = data;
        this.listItems = data.Items;
        this.reportTime = data.ReportTime;
        this.listIcodeSum = data.Sum;
        this.totalRecord = this.listItems.filter(x => x.IsSummary == false).length;


        // 將查詢的資料組成報表html
        //this.insertListData();
        this.insertListData();
      }
    );
  }

  // 取得統計期間的看診人次資料，並組出報表的html內容
  async fetchData2(query: any, allColumns: DailyReportColControl[]) {
    this.allColumns = allColumns.map(x => x.Col);

    this.elContainer = document.getElementById("container");
    this.dailyReport = new DailyReport();

    //this.hst001 = await this.clinicData.getParam("HST001");
    this.isInJail = this.sessionService.getData('useOutVisitJail');
    let hidecolnums = this.prn001?.DailyReportHideCol?.length > 0 ? this.prn001.DailyReportHideCol.split(',')
      .filter(item => !isNaN(Number(item)))  // 過濾掉非數字的子字符串
      .map(item => Number(item)) : [];

    if (query.reportType == 'summary') hidecolnums = hidecolnums.concat([2, 3, 4, 5, 6, 7, 8, 9, 10])

    this.queryRptType = query.reportType;
    this.hidecolArray = DailyReportHideColEnum
      .filter(item => hidecolnums.includes(item.Seq))  // 過濾出序列包含的項目
      .map(item => item.Col);
    const hide = DailyReportHideColEnum.filter(item => hidecolnums.includes(item.Seq))
      .map(item => item.Witdh).reduce((sum, number) => sum + number, 0);
    const totalWidth = allColumns.reduce((sum, column) => sum + column.Witdh, 0) + 15;
    this.fontRange = totalWidth / (totalWidth - hide) <= 1.5 ? totalWidth / (totalWidth - hide) : 1.5;

    this._sDate = query.startDate;
    this._eDate = query.endDate;

    // 條件顯示文字
    if (query.conditionDisplayText && query.conditionDisplayText.trim() !== '') {
      this.condStr = '篩選條件: ' + query.conditionDisplayText;
    } else {
      this.condStr = '';
    }

    this.api.post('GetDailyReport2', query).subscribe(
      (data: DailyReport) => {
        this.dailyReport = data;
        this.listItems = data.Items;
        this.reportTime = data.ReportTime;
        this.listIcodeSum = data.Sum;
        this.totalRecord = this.listItems.filter(x => x.IsSummary == false).length;


        // 將查詢的資料組成報表html
        this.insertListData2();
      }
    );
  }
  // 組報表的html內容
  insertListData() {
    var html_Block = "";
    var iPage = 0;
    var iBlock = 0;
    var isSum = false;
    var nowsearch = new Date();
    this.fontsize = this.printParams.InitFontSize * this.fontRange <= 16.5 ? this.printParams.InitFontSize * this.fontRange : 16.5;
    // const pageRow = this.printParams.InitRow;
    // let  actualPageHeight = (8.5 /this.fontsize ) * pageHeight;
    //let actualRow = Math.floor((this.printParams.InitFontSize / this.fontsize) * pageRow);
    // let row = 1;
    // let detailRow = 0;
    this.nowStr = this.onGetDateString(this.reportTime) + ' ' + this.onGetTimeString(this.reportTime);
    this.elContainer.innerHTML = this.createHTMLPage(iPage);    // 整份報表的html內容
    var html_header = this.createHTMLPageHeader(iPage);     // 頁表頭
    var html_ListerHeader = this.createHTMLListHeader();    // List欄位顯示名稱
    var sum_header = this.createSumListHeader();
    var html_finish = this.createHTMLFinish();              // 報表結束 -- 以下空白
    var elPageContent = document.getElementById("page-" + iPage + "-content");  // 取得某頁的content，每次查詢後會取第0頁
    // 組報表內容
    // [頁表頭][List欄位顯示名稱]
    elPageContent.innerHTML = html_header;
    var elTableContent = document.getElementById("table-" + iPage + "-content");
    elTableContent.innerHTML = html_ListerHeader;
    for (let i = 0; i < this.listItems.length; i++) {
      var prevTableContent = elTableContent.innerHTML;
      // 加入 List 每一筆的內容
      html_Block = this.createHTMLBlock(this.listItems[i]);
      // 判斷是否超出頁面範圍? -> 新增一頁
      // if (row >= actualRow) {
      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        // row = 1;
        // detailRow = 0;
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        // [頁表頭][List欄位顯示名稱]
        html_header = this.createHTMLPageHeader(iPage);
        // html_header = this.createHTMLPageNoHeader(iPage);
        elPageContent.innerHTML += html_header;
        elTableContent = document.getElementById("table-" + iPage + "-content");
        elTableContent.innerHTML = html_ListerHeader;

        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        /*         row += this.coladd
        if (detailRow == 6) {
          detailRow = 0
          row += this.coladd
        }
          */
        this.pageContent[iPage].push(iBlock);
      }

      // if (this.listItems[i].PatientNo == '小計') detailRow += 1;
      elTableContent.innerHTML += html_Block;
      iBlock += 1;
      // this.coladd = 1; //用完歸0
    }
    if (this.listIcodeSum.length > 0 && !isSum) {
      if (elPageContent.offsetHeight + 2 >= this.heightPageWithoutPadding) {
        // elTableContent.innerHTML = prevTableContent;
        // row = 1;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        // [頁表頭][List欄位顯示名稱]
        html_header = this.createHTMLPageSumHeader(iPage);
        // html_header = this.createHTMLPageNoHeader(iPage);
        elPageContent.innerHTML += html_header;
        elTableContent = document.getElementById("table-" + iPage + "-sum");
        elTableContent.innerHTML = sum_header;

        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        // row += 1;
        let sum_first = this.createHTMLPageFirstSumHeader(iPage);
        elPageContent.innerHTML += sum_first;
        var elTableContent = document.getElementById("table-" + iPage + "-sum");
        elTableContent.innerHTML += sum_header;
      }
      isSum = true;
    }
    for (let i = 0; i < this.listIcodeSum.length; i++) {
      // 加入 List 每一筆的內容

      html_Block = this.createSumBlock(this.listIcodeSum[i]);
      var prevTableContent = elTableContent.innerHTML;
      // console.log('html_Block',html_Block);
      elTableContent.innerHTML += html_Block;
      // row += 1 // html_finish // 以下空白
      // console.log('elPageContent.offsetHeight33',elPageContent?.offsetHeight,this.heightPageWithoutPadding);
      // let height = elPageContent.offsetHeight + 51;
      // 判斷是否超出頁面範圍? -> 新增一頁
      if (elPageContent.offsetHeight >= this.heightPageWithoutPadding) {
        // row = 1
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        // [頁表頭][List欄位顯示名稱]
        html_header = this.createHTMLPageSumHeader(iPage);
        // html_header = this.createHTMLPageNoHeader(iPage);
        elPageContent.innerHTML += html_header;
        elTableContent = document.getElementById("table-" + iPage + "-sum");
        elTableContent.innerHTML = sum_header;

        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        // row += 1
        this.pageContent[iPage].push(iBlock);
      }
      iBlock += 1;
    }
    elPageContent.innerHTML += html_finish;

    // 設定所有頁面的總頁數
    for (var i = 0; i <= iPage; i++) {
      var totalPageSpan = document.getElementById("totalPage-" + i);
      if (totalPageSpan) {
        totalPageSpan.innerHTML = (iPage + 1).toString();
      }
    }

    // 移除列印時不需要的 excelver 欄位和 onlyexcel 標題
    setTimeout(() => {
      let htmlreport = this.reportContainer.nativeElement.innerHTML;
      htmlreport = htmlreport.replace(/<td[^>]*\bexcelver\b[^>]*>[\s\S]*?<\/td>/gi, '');
      htmlreport = htmlreport.replace(/<th[^>]*\bonlyexcel\b[^>]*>[\s\S]*?<\/th>/gi, '');
      this.reportContainer.nativeElement.innerHTML = htmlreport;
    }, 0);
  }

  insertListData2() {
    var html_Block = "";
    var iPage = 0;
    var iBlock = 0;
    var isSum = false;
    this.fontsize = this.printParams.InitFontSize * this.fontRange <= 16.5 ? this.printParams.InitFontSize * this.fontRange : 16.5;

    this.nowStr = this.onGetDateString(this.reportTime) + ' ' + this.onGetTimeString(this.reportTime);
    var styles = this.createHTMLStyle();
    var pageTemplate = '';//this.createHTMLPage2(iPage,true);
    //this.elContainer.innerHTML = this.createHTMLPage(iPage);    // 整份報表的html內容

    //var html_header = this.createHTMLPageHeader2(iPage);     // 頁表頭
    var html_ListerHeader = this.createHTMLListHeader2();    // List欄位顯示名稱
    var sum_header = this.createSumListHeader();
    var html_finish = this.createHTMLFinish();              // 報表結束 -- 以下空白
    //pageTemplate = pageTemplate.replace(`{{page-` + iPage + `-content}}`,html_header)
    // 組報表內容
    // [頁表頭][List欄位顯示名稱]
    //pageTemplate = pageTemplate.replace(`{{table-` + iPage + `-content}}`,html_ListerHeader)
    var rowCount = this.prn001.DailyReportType == 2 ? 32 : 52;
    var curRow = 0;
    var tableContent = html_ListerHeader
    var pageContent = '';
    var reportHtml: string[] = [];

    for (let i = 0; i < this.listItems.length; i++) {
      // 新的一頁
      if (curRow == 0) {
        //產生Page
        pageTemplate = this.createHTMLPage2(iPage);
        //表格容器
        pageContent = this.createHTMLPageHeader2(iPage);
        //表格先塞入標頭
        tableContent = html_ListerHeader
      }
      //表格插入資料行
      tableContent += this.createHTMLBlock2(this.listItems[i])
      curRow++;
      if (curRow == rowCount) {
        //置入表格內容
        pageContent = pageContent.replace(`{{table-${iPage}-content}}`, tableContent)
        //置入頁面內容
        pageTemplate = pageTemplate.replace(`{{page-${iPage}-content}}`, pageContent)
        //移除多於內容
        pageTemplate = pageTemplate.replace(/<td[^>]*\bexcelver\b[^>]*>[\s\S]*?<\/td>/gi, '');
        pageTemplate = pageTemplate.replace(/<th[^>]*\bonlyexcel\b[^>]*>[\s\S]*?<\/th>/gi, '');
        //本頁加入整張報表中
        reportHtml.push(pageTemplate);
        //頁碼+1
        iPage += 1;
        //重製行數
        curRow = 0;
      }
    }
    if (curRow != rowCount) {
      //置入表格內容
      pageContent = pageContent.replace(`{{table-${iPage}-content}}`, tableContent)
      //置入頁面內容
      pageTemplate = pageTemplate.replace(`{{page-${iPage}-content}}`, pageContent)
      //移除多於內容
      pageTemplate = pageTemplate.replace(/<td[^>]*\bexcelver\b[^>]*>[\s\S]*?<\/td>/gi, '');
      pageTemplate = pageTemplate.replace(/<th[^>]*\bonlyexcel\b[^>]*>[\s\S]*?<\/th>/gi, '');
      //最末頁繼續保留置入後續內容 故不推入reportHtml
    }
    var sumContent = sum_header;
    if (this.listIcodeSum.length > 0 && !isSum) {
      // 如果需要切頁(高度不足)
      if (curRow >= rowCount - 2) {
        // 把前面最後一頁放進去
        reportHtml.push(pageTemplate);
        //換下頁
        iPage += 1;
        curRow = 0;
      }
      // 產製下一頁
      if (curRow == 0) {
        //建立下一頁內容
        pageTemplate = this.createHTMLPage2(iPage);
        //Sum表格容器
        pageContent = this.createHTMLPageSumHeader2(iPage)
      } else {
        // 修正跑不出sum內容
        pageTemplate = this.createHTMLPage2(iPage);
        //不須切頁
        let sum_first = this.createHTMLPageFirstSumHeader2(iPage);
        //置入表格容器
        pageContent += sum_first;
        //給他兩航高度
        curRow += 2;
      }
      isSum = true;
    }
    //處理統計值
    for (let i = 0; i < this.listIcodeSum.length; i++) {
      // 加入 List 每一筆的內容
      html_Block = this.createSumBlock(this.listIcodeSum[i]);
      //加入統計值表格行
      sumContent += html_Block;
      curRow++;
      // 判斷是否超出頁面範圍? -> 新增一頁
      if (curRow >= rowCount) {
        //表格內容置入
        pageContent = pageContent.replace(`{{table-${iPage}-sum}}`, sumContent)
        //置入頁面內容
        pageTemplate = pageTemplate.replace(`{{page-${iPage}-content}}`, pageContent)
        // 把前面最後一頁放進去
        reportHtml.push(pageTemplate);
        //換下頁
        iPage += 1;
        curRow = 0;
        //建立下一頁內容
        pageTemplate = this.createHTMLPage2(iPage);
        //Sum表格容器
        pageContent = this.createHTMLPageSumHeader2(iPage)
        //表格置入標頭
        sumContent = sum_header;
      }
      iBlock += 1;
    }
    //殘留回收
    if (curRow !== rowCount) {
      //表格內容置入
      pageContent = pageContent.replace("{{table-" + iPage + "-sum}}", sumContent)
      //以下空白,沒殘留頁就不加這行
      pageContent += html_finish;
      //置入頁面內容
      pageTemplate = pageTemplate.replace("{{page-" + iPage + "-content}}", pageContent)
      reportHtml.push(pageTemplate);
    }

    // 設定所有頁面的總頁數
    for (var i = 0; i <= iPage; i++) {
      reportHtml[i] = reportHtml[i].replace(`{{totalPage-${i}}}`, (iPage + 1).toString())
    }

    this.elContainer.innerHTML = styles + reportHtml.join('');


  }
  convertPxToCm(px) {
    return Math.round(((px * 2.54) / 96) * 100) / 100;
  }

  convertCmtoPx(cm) {
    return Math.round((cm * 96) / 2.54);
  }

  createHTMLPage(iPage, addReplaceTag = false) {
    let page = '';
    if (this.forExcel) {
      page += `
          <style>
            .excel-format {
              font-size: 12pt;
            }
            .excel-format-text {
              font-size: ${this.fontsize}pt;
              mso-number-format: "@";
            }
          </style>`;
    }
    page += `<div class="page" id="page-` + iPage + `"
      style="
      margin: 0px auto;
      height: ` + this.printParams.PageHeight + `cm;
      width: ` + this.printParams.PageWidth + `cm;
      padding-top: ` + this.printParams.PagePaddingTop + `cm;
      padding-right: ` + this.printParams.PagePaddingRight + `cm;
      padding-bottom: ` + this.printParams.PagePaddingBottom + `cm;
      padding-left: ` + this.printParams.PagePaddingLeft + `cm;
      display: block;
      margin: 0px auto;
      box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.05);
      box-sizing: border-box;
      ">
      <div class="content" id="page-` + iPage + `-content">`
      + (addReplaceTag ? `{{page-` + iPage + `-content}}` : '') +
      `</div>
  </div>`;


    return page;
  }
  createHTMLStyle() {
    return `
          <style>
            .excel-format {
              font-size: 12pt;
            }
            .excel-format-text {
              font-size: ${this.fontsize}pt;
              mso-number-format: "@";
            }
            .excel-format-number {
              font-size: ${this.fontsize}pt;
              mso-number-format: "0";
            }
            .rpt-page {
              margin: 0px auto;
              height: ` + this.printParams.PageHeight + `cm;
              width: ` + this.printParams.PageWidth + `cm;
              padding-top: ` + this.printParams.PagePaddingTop + `cm;
              padding-right: ` + this.printParams.PagePaddingRight + `cm;
              padding-bottom: ` + this.printParams.PagePaddingBottom + `cm;
              padding-left: ` + this.printParams.PagePaddingLeft + `cm;
              display: block;
              margin: 0px auto;
              box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.05);
              box-sizing: border-box;
            }
            .rpt-page-header{
              margin: 0px 2px;
            }
            .rpt-page-header>div>table {
              width: 100%;border: none;
            }
            .rpt-title{
              height: 30px; text-align: center; font-weight: bolder;font-family:標楷體; font-size: 17.5pt;font-weight: 600; border: none !important;
            }
            .rpt-date{
              font-family:標楷體;width: 30%;font-size: 15.5px;font-weight: 600; text-align: left; padding-top: 5px; border: none !important;
            }
            .rpt-region{
              font-family:標楷體;width: 40%;font-size: 15.5px;font-weight: 600; text-align: center; border: none !important;
            }
            .rpt-page-no{
              font-family:標楷體;width: 30%; font-size: 15.5px;font-weight: 600; text-align: right; border: none !important;
            }
            .rpt-filter{
              font-size: 15.5px;font-family:標楷體;font-weight: 600; text-align: left; padding-top: 5px; border: none !important;
            }
            .rpt-table-container{
              -webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px;
            }
            .rpt-table-container>div>table {
              width: 100%;border: none;
            }
            .rpt-table-gap{
              -webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px; text-align: center;"
            }
            .rpt-table-gap>label{
              font-weight: bold; height: 23px;
            }
            .rpt-th{
              border-right: 0px solid black;
              border-left: 0px solid black;
              border-top: none;
              border-bottom: 5px double black;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
              .rpt-td{
              border-top: none;
              white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
              }
            .alg-left{
              text-align:left;
            }
            .alg-right{
              text-align:right;
            }
            .alg-center{
              text-align:center;
            }
            .ls-n{
              letter-spacing:0pt
            }
            .ls-l{
              letter-spacing:-0.75pt
            }

            .ls-s{
              letter-spacing:-0.25pt
            }
              .n-b-b{
              border-bottom: none !important;
              }
          </style>`;
  }
  createHTMLPage2(iPage) {
    let page =
      `<div class="page rpt-page" id="page-${iPage}">
      <div class="content" id="page-${iPage}-content">
        {{page-${iPage}-content}}
      </div>
    </div>`;
    return page;
  }
  createHTMLListHeader(isForExcel: boolean = false) {
    this.columnLine = -2; // 小計分隔線長度,從第3個欄位開始算起
    var maxwidth = this.listItems.length > 0 ? 'max-width:0.1%;' : '';

    var jainfo = this.isInJail ?
      this.createColHeader('身分證號', 'PatientCid', 53, 'left', 1, true) +
      this.createColHeader('特治', 'Sptx', 30, 'left', 1, true) +
      this.createColHeader('呼號', 'JaAddr', 30, 'left', 1, true) +
      this.createColHeader('場舍', 'JaPhone', 30, 'left', 1, true) : '';

    // 根據是否為Excel決定欄位名稱
    const col_patientNo = isForExcel ? '病歷號' : '證號';
    const col_icodeName = isForExcel ? '身分' : '身';
    const col_timeSecName = isForExcel ? '時段' : '段';
    const col_statusWord = isForExcel ? '狀態' : '狀';
    const col_dispTp = isForExcel ? '調劑' : '調';
    const col_sameTreat = isForExcel ? '類' : 'TP';
    const col_doctorName = isForExcel ? '醫師' : '醫';
    const col_aPartOPD = isForExcel ? '部分負擔' : '自付費';
    const col_aPartDrug = isForExcel ? '藥部分負擔' : '藥自付';
    const col_aPartExam = isForExcel ? '檢部分負擔' : '檢自付';

    return '<tr class="list-header" style="width:100%">' +
      this.createColHeader(col_patientNo, 'PatientNo', 45, 'left') +
      this.createColHeader('姓名', 'PatientName', 58, 'left') +
      this.createColHeader('初複診', 'VisitSourceCode', 30, 'left') +
      this.createColHeader('日期', 'Date', 45, 'left') +
      this.createColHeader('過卡時間', 'Icdt', 45, 'left') +
      this.createColHeader(col_icodeName, 'IcodeName', 33, 'left') +
      jainfo +
      this.createColHeader('卡序', 'Isqno', 28, 'left') +
      this.createColHeader(col_timeSecName, 'TimeSecName', 14, 'left') +
      this.createColHeader(col_statusWord, 'StatusWord', 33, 'left') +
      this.createColHeader(col_dispTp, 'DispTp', 14, 'left') +
      this.createColHeader(col_sameTreat, 'SameTreat', 16, 'left') +
      this.createColHeader('次', 'CusNo', 16, 'left') +
      this.createColHeader('櫃檯員', 'DUTYCreater', 49, 'left', 0.950) +
      this.createColHeader('診', 'RoomCode', 14, 'left') +
      this.createColHeader(col_doctorName, 'DoctorName', 52, 'left') +
      // 費用區 靠右
      this.createColHeader('掛號費', 'FeeReg', 46, 'right', 0.975) +
      this.createColHeader(col_aPartOPD, 'APartOPD', 46, 'right', 0.975) +
      this.createColHeader('自費', 'AOwn', 49, 'right') +
      this.createColHeader('押金', 'FeeLAMT', 47, 'right') +
      this.createColHeader(col_aPartDrug, 'APartDrug', 46, 'right', 0.975) +
      this.createColHeader(col_aPartExam, 'APartExam', 46, 'right', 0.975) +
      this.createColHeader('欠款', 'Debt', 47.5, 'right') +
      this.createColHeader('還款', 'Repay', 47.5, 'right') +
      this.createColHeader('小計', 'Received', 49, 'right') +
      this.createColHeader('掛帳費', 'FeeTotal', 47, 'right', 0.975) +
      this.createColHeader('', 'space', 0.2, 'left') +
      this.createColHeader('說明', 'Remark', 70, 'left') +
      this.createColHeader('現金', 'PaidCash', 46, 'right', 0.975) +
      this.createColHeader('信用卡', 'PaidCreditCard', 46, 'right', 0.975) +
      this.createColHeader('現金卡', 'PaidCashCard', 46, 'right', 0.975) +
      this.createColHeader('醫保卡', 'PaidMedCard', 46, 'right', 0.975) +
      this.createColHeader('轉帳', 'PaidTransfer', 46, 'right', 0.975) +
      this.createColHeader('電子支付', 'PaidEPayment', 60, 'right', 0.975) +
      this.createColHeader('其他', 'PaidOther', 46, 'right', 0.975) +
      this.createColHeader('付款小計', 'PaidSum', 60, 'right', 0.975) +
      '</tr>';
  }

  createHTMLListHeader2(isForExcel: boolean = false) {
    this.columnLine = -2; // 小計分隔線長度,從第3個欄位開始算起
    var maxwidth = this.listItems.length > 0 ? 'max-width:0.1%;' : '';

    var jainfo = this.isInJail ?
      this.createColHeader2('身分證號', 'PatientCid', 53, 'left', 1, true) +
      this.createColHeader2('特治', 'Sptx', 30, 'left', 1, true) +
      this.createColHeader2('呼號', 'JaAddr', 30, 'left', 1, true) +
      this.createColHeader2('場舍', 'JaPhone', 30, 'left', 1, true) : '';

    // 根據是否為Excel決定欄位名稱
    const col_patientNo = isForExcel ? '病歷號' : '證號';
    const col_icodeName = isForExcel ? '身分' : '身';
    const col_timeSecName = isForExcel ? '時段' : '段';
    const col_statusWord = isForExcel ? '狀態' : '狀';
    const col_dispTp = isForExcel ? '調劑' : '調';
    const col_sameTreat = isForExcel ? '類' : 'TP';
    const col_doctorName = isForExcel ? '醫師' : '醫';
    const col_aPartOPD = isForExcel ? '部分負擔' : '自付費';
    const col_aPartDrug = isForExcel ? '藥部分負擔' : '藥自付';
    const col_aPartExam = isForExcel ? '檢部分負擔' : '檢自付';

    return '<tr class="list-header" style="width:100%">' +
      this.createColHeader2(col_patientNo, 'PatientNo', 45, 'left') +
      this.createColHeader2('姓名', 'PatientName', 58, 'left') +
      this.createColHeader2('初/複', 'VisitSourceCode', 35, 'left') +
      this.createColHeader2('日期', 'Date', 45, 'left') +
      this.createColHeader2('過卡時間', 'Icdt', 45, 'left') +
      this.createColHeader2(col_icodeName, 'IcodeName', 33, 'left') +
      jainfo +
      this.createColHeader2('卡序', 'Isqno', 28, 'left') +
      this.createColHeader2(col_timeSecName, 'TimeSecName', 14, 'left') +
      this.createColHeader2(col_statusWord, 'StatusWord', 33, 'left') +
      this.createColHeader2(col_dispTp, 'DispTp', 14, 'left') +
      this.createColHeader2(col_sameTreat, 'SameTreat', 16, 'left') +
      this.createColHeader2('次', 'CusNo', 16, 'left') +
      this.createColHeader2('櫃檯員', 'DUTYCreater', 49, 'left', 0.950) +
      this.createColHeader2('診', 'RoomCode', 14, 'left') +
      this.createColHeader2(col_doctorName, 'DoctorName', 52, 'left') +
      // 費用區 靠右
      this.createColHeader2('掛號費', 'FeeReg', 46, 'right', 0.975) +
      this.createColHeader2(col_aPartOPD, 'APartOPD', 46, 'right', 0.975) +
      this.createColHeader2('自費', 'AOwn', 49, 'right') +
      this.createColHeader2('押金', 'FeeLAMT', 47, 'right') +
      this.createColHeader2(col_aPartDrug, 'APartDrug', 46, 'right', 0.975) +
      this.createColHeader2(col_aPartExam, 'APartExam', 46, 'right', 0.975) +
      this.createColHeader2('欠款', 'Debt', 47.5, 'right') +
      this.createColHeader2('還款', 'Repay', 47.5, 'right') +
      this.createColHeader2('小計', 'Received', 49, 'right') +
      this.createColHeader2('掛帳費', 'FeeTotal', 47, 'right', 0.975) +
      this.createColHeader2('', 'space', 0.2, 'left') +
      this.createColHeader2('說明', 'Remark', 70, 'left') +
      this.createColHeader2('現金', 'PaidCash', 46, 'right', 0.975) +
      this.createColHeader2('信用卡', 'PaidCreditCard', 46, 'right', 0.975) +
      this.createColHeader2('現金卡', 'PaidCashCard', 46, 'right', 0.975) +
      this.createColHeader2('醫保卡', 'PaidMedCard', 46, 'right', 0.975) +
      this.createColHeader2('轉帳', 'PaidTransfer', 46, 'right', 0.975) +
      this.createColHeader2('電子支付', 'PaidEPayment', 60, 'right', 0.975) +
      this.createColHeader2('其他', 'PaidOther', 46, 'right', 0.975) +
      this.createColHeader2('付款小計', 'PaidSum', 60, 'right', 0.975) +
      '</tr>';
  }
  createColHeader(cName: string, tName: string, width: number, tAlign: string, smallrange: number = 1, isOnlyForExcel: boolean = false) {
    const fontInitSize = this.printParams.InitFontSize - 0.5;
    let actualWitdh = width;
    let widthUnit = 'pt';

    // Excel 模式下使用百分比
    if (this.forExcel) {
      actualWitdh = (width / 1000) * 100;
      widthUnit = '%';
    } else if ((tName == 'PatientName' || tName == 'DoctorName' || tName == 'DUTYCreater' || tName == 'Remark') && this.fontsize > fontInitSize) {
      actualWitdh = actualWitdh * 1.04 * (this.fontsize / this.printParams.InitFontSize)
    }

    var remark = isOnlyForExcel ? 'onlyexcel' : '';
    var actualfontSize = this.fontsize * smallrange;
    if (!this.allColumns.includes(tName) || this.hidecolArray.includes(tName)) {
      return ''
    } else {
      this.columnLine++;
      return `<th ${remark}  style="text-align: ${tAlign};width:${actualWitdh}${widthUnit};font-size:${actualfontSize}pt; border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;
         white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
        ${cName}
        </th>`;
    }
  }
  createColHeader2(cName: string, tName: string, width: number, tAlign: 'left' | 'right' | 'center', smallrange: number = 1, isOnlyForExcel: boolean = false) {
    const fontInitSize = this.printParams.InitFontSize - 0.5;
    let actualWitdh = width;
    let widthUnit = 'pt';

    // Excel 模式下使用百分比
    if (this.forExcel) {
      actualWitdh = (width / 1000) * 100;
      widthUnit = '%';
    } else if ((tName == 'PatientName' || tName == 'DoctorName' || tName == 'DUTYCreater' || tName == 'Remark') && this.fontsize > fontInitSize) {
      actualWitdh = actualWitdh * 1.04 * (this.fontsize / this.printParams.InitFontSize)
    }

    var remark = isOnlyForExcel ? 'onlyexcel' : '';
    var actualfontSize = this.fontsize * smallrange;
    var cls = `rpt-th alg-${tAlign} `

    if (!this.allColumns.includes(tName) || this.hidecolArray.includes(tName)) {
      return ''
    } else {
      this.columnLine++;
      return `<th ${remark} class="${cls}" style="width:${actualWitdh}${widthUnit};font-size:${actualfontSize}pt;">
        ${cName}
        </th>`;
    }
  }
  createSumListHeader() {
    var additionstr = `<th style="text-align: right;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    掛號費
    </th>
    <th style="text-align: right;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    自付費
    </th>
    <th style="text-align: right;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    自費額
    </th>
    <th style="text-align: right;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    淨押金
    </th>
    <th style="text-align: right;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    欠還藥
    </th>
    <th style="text-align: right;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    檢自付
    </th>
    <th style="text-align: right;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    小計
    </th>
    </tr>`
    let addStr = this.isHomeCare ? additionstr : '';
    return `<tr  class="sum-list-header">
    <th style="text-align: left;max-width: 3rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    身分
    </th>
    <th style="text-align: right;max-width: 2rem;min-width: 3rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    人次
    </th>
    <th style="text-align: right;max-width: 2rem;min-width: 2rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    初診
    </th>
    <th style="text-align: right;max-width: 2rem;min-width: 2rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    複診
    </th>
    <th style="text-align: right;max-width: 2rem;min-width: 2rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    欠卡
    </th>
    <th style="text-align: right;max-width: 2rem;min-width: 2rem;border-right: 0px solid black;border-left: 0px solid black;border-top: none;border-bottom: 5px double black;">
    還卡
    </th>`
      +
      addStr;
  }
  stringFactory(input: string): string {
    return !NullOrEmpty(input) ? input.trimRight() : ' ';
  }
  stringLengthFactory(src: string, maxlength: number, symbol: string): string {
    if (src == null || src == '' || src == undefined) return ''      // 使用正規表達式匹配中文字符
    const chineseCharacters = src.match(/[\u4e00-\u9fa5]/g);
    const fullWidthPattern = /[\uFF01-\uFF60\uFFE0-\uFFE6]/g;

    let initlength = 0;
    // 如果沒有中文字符，則返回整個字串的長度
    for (let ind = 0; ind < src.length; ind++) {
      let chineseAlpha = src[ind].match(/[\u4e00-\u9fa5]/g);
      let fullWidthAlpha = src[ind].match(/[\uFF01-\uFF60\uFFE0-\uFFE6]/g);
      if (chineseAlpha) initlength += 2;
      else if (fullWidthAlpha) initlength += 2;
      else initlength += 1;
      if (initlength >= maxlength) {
        return src.substr(0, ind) + symbol;
      }
    }
    return src;

  }
  numberFactory(input: number): string {
    let result = '';
    if (!isNaN(input)) {
      result = input > 0 ? input.toString() : '0';
    }
    let paddedString = this.padToLength(result, 4, " ");
    return paddedString;
  }
  numberFeeFactory(input: number): string {
    if (!isNaN(input)) {
      return input.toString();
    }
    return '';
  }
  padToLength(inputString: string, targetLength: number, paddingChar: string): string {
    const paddingLength = targetLength - inputString.length;
    if (paddingLength > 0) {
      return inputString + paddingChar.repeat(paddingLength);
    } else {
      return inputString;
    }
  }


  stringBFactory(input: string): string {
    let str = !NullOrEmpty(input) ? input : '';
    let inputSlice = str.length >= 4 ? str.slice(0, 4) + '..' : str;
    return inputSlice;
  }
  stringCFactory(input: string): string {
    let str = !NullOrEmpty(input) ? input : '';
    let inputSlice = str.length > 7 ? str.slice(-7) : str;
    return inputSlice;
  }
  stringTimeZone(input: string): string {
    let result = !NullOrEmpty(input) ? input.trimRight() : ' ';
    switch (input) {
      case '早上':
        result = '早';
        break;
      case '下午':
        result = '午';
        break;
      case '晚上':
        result = '晚';
        break;
      default:
        result = ' ';
        break;
    }
    return result;
  }

  createSumBlock(data: DailyReportIcodeSum) {
    var summaryStyle = "border-top: none;";
    var icode = this.stringBFactory(data.Icode);
    var people = this.numberFactory(data.People);
    var firstvisit = this.numberFactory(data.NumberOfFirstVisitPeople);
    var moreonevisit = this.numberFactory(data.NumberOfRevisitPeople);
    var cardarrear = this.numberFactory(data.NumberOfType3People);
    var recard = this.numberFactory(data.NumberOfType3RecardPeople);

    var feeReg = this.numberFeeFactory(data.FeeReg);
    var feeApartOpd = this.numberFeeFactory(data.APartOPD);
    var ownFee = this.numberFeeFactory(data.FeeOwn);
    var deposit = this.numberFeeFactory(data.Deposit);
    var feeAPartDrug = this.numberFeeFactory(data.APartDrug);
    var feeAPartExam = this.numberFeeFactory(data.APartExam);
    var subSum = this.numberFeeFactory(data.SubSum);
    let additionstr =
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + feeReg + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + feeApartOpd + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + ownFee + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + deposit + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + feeAPartDrug + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + feeAPartExam + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + subSum + '</td>';
    let addStr = this.isHomeCare ? additionstr : '';
    return '<tr>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none;">' + icode + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + people + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + firstvisit + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + moreonevisit + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + cardarrear + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + recard + '</td>' +
      addStr +
      '</tr>';
  }

  createHTMLBlock(data: DailyReportItem, isForExcel: boolean = false) {
    var summaryStyle = "border-top: none;";
    var summaryFontStyle = data.IsSummary ? "font-weight: bold" : "";
    var patientNo = this.stringCFactory(data.PatientNo);
    // var patientName = this.stringLengthFactory(data.PatientName,7,'..');
    //姓名完整顯示
    var patientName = this.stringFactory(data.PatientName);
    var patientWholeName = this.stringFactory(data.PatientName);
    var visitSourceCode = this.stringFactory(data.VisitSourceCode);

    var patientCid = this.stringFactory(data.PatientCid);
    var sptxExcel = this.stringFactory(data.Sptx);
    var jaaddrExcel = this.stringFactory(data.JaAddr);
    var japhoneExcel = this.stringFactory(data.JaPhone);

    // 小計和總計行不顯示日期
    var date = (data.PatientNo === '小計' || data.PatientNo === '總計') && this.queryRptType != 'summary' ? '' : DateHelper.formatROCDate(data.RegDate);
    var icdt = (data.PatientNo === '小計' || data.PatientNo === '總計') ? '' : DateHelper.toROCDateTimeString(data.Icdt);

    var icode = this.stringLengthFactory(data.IcodeName, 5, '');
    var icno = this.stringFactory(data.Isqno);
    var timeSecName = this.stringTimeZone(data.TimeSecName);
    var status = this.stringFactory(data.StatusWord);
    var tp = this.stringFactory(data.SameTreat);

    var dutyCreater = this.stringLengthFactory(data.DUTYCreater, 7, '..');
    var dutyCreaterWholeName = this.stringFactory(data.DUTYCreater);
    var roomCode = this.stringFactory(data.RoomCode);
    var doctor = this.stringLengthFactory(data.DoctorName, 7, '..');
    var doctorWholeName = this.stringFactory(data.DoctorName);

    var feeReg = this.numberFeeFactory(data.FeeReg);

    var feeApartOpd = this.numberFeeFactory(data.APartOPD);
    var feeAPartDrug = this.numberFeeFactory(data.APartDrug);
    var ownFee = this.numberFeeFactory(data.AOwn);
    var deposit = this.numberFeeFactory(data.FeeLAMT);
    var aPartExam = this.numberFeeFactory(data.APartExam);
    var debt = this.numberFeeFactory(data.Debt);
    var repay = this.numberFeeFactory(data.Repay);

    var received = this.numberFeeFactory(data.Received);
    var feeTotal = this.numberFeeFactory(data.FeeTotal);
    var remark = this.stringLengthFactory(data.Remark, 30, '‥');
    var remarkExcel = this.stringFactory(data.Remark);

    var paidCash = this.numberFeeFactory(data.PaidCash);
    var paidCreditCard = this.numberFeeFactory(data.PaidCreditCard);
    var paidCashCard = this.numberFeeFactory(data.PaidCashCard);
    var paidMedCard = this.numberFeeFactory(data.PaidMedCard);
    var paidTransfer = this.numberFeeFactory(data.PaidTransfer);
    var paidEPayment = this.numberFeeFactory(data.PaidEPayment);
    var paidOther = this.numberFeeFactory(data.PaidOther);
    var paidSum = this.numberFeeFactory(data.PaidSum);

    // Excel匯出時不加空行, 列印時才加
    var blankLine = (data.PatientNo === '總計' && !isForExcel) ? '<tr><td colspan="24" style="border-right: none; border-left: none; border-bottom: none; border-top: none;"></td></tr>' : '';
    // 小計行: 列印時加分隔線tr,Excel時不加(改用td的border-bottom)
    var subLine = (data.PatientNo === '小計' && !isForExcel) ? `<tr><td colspan="2" style="border-bottom: none !important; border-top: none;"></td><td colspan="${this.columnLine}" style="border-right: none; border-left: none; border-bottom: 1.5px double black; border-top: none;"></td></tr>` : ''; var isublinestyle = data.PatientNo === '小計' || data.PatientNo === '總計' ? 'right' : 'left';

    // Excel模式下,小計&總計行的td要加border-bottom
    var subCellStyle = ((data.PatientNo === '小計' || data.PatientNo === '總計') && isForExcel) ? 'border-bottom: 1.5px double black;' : '';
    var subCellStylePN = ((data.PatientNo === '小計' || data.PatientNo === '總計') && !isForExcel && this.queryRptType == 'summary') ? 'padding-right: 10px;' : '';

    var jainfo = this.isInJail ? this.createColBlock(patientCid, 'PatientCid', 'left', 0, true, subCellStyle) + this.createColBlock(sptxExcel, 'Sptx', 'left', 0, true, subCellStyle) + this.createColBlock(jaaddrExcel, 'JaAddr', 'left', 0, true, subCellStyle) + this.createColBlock(japhoneExcel, 'JaPhone', 'left', 0, true, subCellStyle) : '';

    return blankLine + '<tr>' + this.createColBlock(patientNo, 'PatientNo', 'left', -0.75, false, subCellStyle) + this.createColBlock(patientName, 'PatientName', isublinestyle, 0, false, subCellStyle, subCellStylePN) + this.createColBlock(visitSourceCode, 'VisitSourceCode', 'left', 0, false, subCellStyle) + this.createColBlock(patientWholeName, 'PatientName', isublinestyle, 0, true, subCellStyle)
      + this.createColBlock(date, 'Date', 'left', -0.75, false, subCellStyle) + this.createColBlock(icdt, 'Icdt', 'left', 0, false, subCellStyle) + this.createColBlock(icode, 'IcodeName', 'left', -0.25, false, subCellStyle)
      + jainfo
      + this.createColBlock(icno, 'Isqno', 'left', 0, false, subCellStyle) + this.createColBlock(timeSecName, 'TimeSecName', 'left', -0.25, false, subCellStyle)
      + this.createColBlock(status, 'StatusWord', 'left', -0.25, false, subCellStyle) + this.createColBlock(' ', 'DispTp', 'left', 0, false, subCellStyle)
      + this.createColBlock(tp, 'SameTreat', 'left', 0, false, subCellStyle) + this.createColBlock(' ', 'CusNo', 'left', 0, false, subCellStyle) + this.createColBlock(dutyCreater, 'DUTYCreater', 'left', -0.25, false, subCellStyle) + this.createColBlock(dutyCreaterWholeName, 'DUTYCreater', 'left', 0, true, subCellStyle)
      + this.createColBlock(roomCode, 'RoomCode', 'left', 0, false, subCellStyle) + this.createColBlock(doctor, 'DoctorName', 'left', 0, false, subCellStyle) + this.createColBlock(doctorWholeName, 'DoctorName', 'left', 0, true, subCellStyle)
      + this.createColBlock(feeReg, 'FeeReg', 'right', -0.75, false, subCellStyle) + this.createColBlock(feeApartOpd, 'APartOPD', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(ownFee, 'AOwn', 'right', -0.75, false, subCellStyle) + this.createColBlock(deposit, 'FeeLAMT', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(feeAPartDrug, 'APartDrug', 'right', -0.75, false, subCellStyle) + this.createColBlock(aPartExam, 'APartExam', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(debt, 'Debt', 'right', -0.75, false, subCellStyle) + this.createColBlock(repay, 'Repay', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(received, 'Received', 'right', -0.75, false, subCellStyle) + this.createColBlock(feeTotal, 'FeeTotal', 'right', -0.75, false, subCellStyle)
      + this.createColBlock('', 'space', 'right', 0, false, subCellStyle) + this.createColBlock(remark, 'Remark', 'left', -0.25, false, subCellStyle) + this.createColBlock(remarkExcel, 'Remark', 'left', 0, true, subCellStyle)
      + this.createColBlock(paidCash, 'PaidCash', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(paidCreditCard, 'PaidCreditCard', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(paidCashCard, 'PaidCashCard', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(paidMedCard, 'PaidMedCard', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(paidTransfer, 'PaidTransfer', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(paidEPayment, 'PaidEPayment', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(paidOther, 'PaidOther', 'right', -0.75, false, subCellStyle)
      + this.createColBlock(paidSum, 'PaidSum', 'right', -0.75, false, subCellStyle)
      + '</tr>'
      + subLine;
  }

  createColBlock(value: string, tName: string, align: string, letterSpacing = 0, isExcel = false, extraStyle = '', extraStyle2 = '') {
    if (!this.allColumns.includes(tName) || this.hidecolArray.includes(tName)) return ''

    var da = DailyReportColEnum.find(x => x.Col == tName);
    if (da && da.Height > 1 && da.IsNeedHide == false && value) this.coladd = da.Height;

    var remark = (tName == 'Remark' || tName == 'PatientName' || tName == 'DUTYCreater' ||
      tName == 'DoctorName' || tName == 'PatientCid' || tName == 'Sptx' ||
      tName == 'JaAddr' || tName == 'JaPhone') ? isExcel ? 'excelver' : 'htmlver' : '';

    const numberCols = [
      'FeeReg', 'APartOPD', 'AOwn', 'FeeOwn', 'FeeLAMT', 'Deposit',
      'APartDrug', 'APartExam', 'Debt', 'Repay', 'Received', 'FeeTotal', 'SubSum',
      'PaidCash', 'PaidCreditCard', 'PaidCashCard', 'PaidMedCard',
      'PaidTransfer', 'PaidEPayment', 'PaidOther', 'PaidSum'
    ];
    var tdClass = numberCols.includes(tName) ? 'excel-format-number' : 'excel-format-text';

    // 只在非Excel模式時強制border-bottom: none,Excel模式使用extraStyle
    var borderBottom = extraStyle ? extraStyle : 'border-bottom: none !important;';

    var style = `text-align: ${align};letter-spacing: ${letterSpacing}pt;border-top: none;${borderBottom}${extraStyle2}`;

    return `<td ${remark} style="${style};white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;" class="${tdClass}">${value}</td>`;
    //return `<td ${remark} ${excelFormat} style="text-align: ${align};letter-spacing: ${letterSpacing}pt;border-top: none;${borderBottom}" class="excel-format-text">${value}</td>`
  }
  createHTMLBlock2(data: DailyReportItem, isForExcel: boolean = false) {
    var patientNo = this.stringCFactory(data.PatientNo);
    // var patientName = this.stringLengthFactory(data.PatientName,7,'..');
    //姓名完整顯示
    var patientName = this.stringFactory(data.PatientName);
    var patientWholeName = this.stringFactory(data.PatientName);
    var visitSourceCode = this.stringFactory(data.VisitSourceCode);

    var patientCid = this.stringFactory(data.PatientCid);
    var sptxExcel = this.stringFactory(data.Sptx);
    var jaaddrExcel = this.stringFactory(data.JaAddr);
    var japhoneExcel = this.stringFactory(data.JaPhone);

    // 小計和總計行不顯示日期
    var date = (data.PatientNo === '小計' || data.PatientNo === '總計') && this.queryRptType != 'summary' ? '' : DateHelper.formatROCDate(data.RegDate);
    var icdt = (data.PatientNo === '小計' || data.PatientNo === '總計') ? '' : DateHelper.toROCDateTimeString(data.Icdt);

    var icode = this.stringLengthFactory(data.IcodeName, 5, '');
    var icno = this.stringFactory(data.Isqno);
    var timeSecName = this.stringTimeZone(data.TimeSecName);
    var status = this.stringFactory(data.StatusWord);
    var tp = this.stringFactory(data.SameTreat);

    var dutyCreater = this.stringLengthFactory(data.DUTYCreater, 7, '..');
    var dutyCreaterWholeName = this.stringFactory(data.DUTYCreater);


    var roomCode = this.stringFactory(data.RoomCode);
    var doctor = this.stringLengthFactory(data.DoctorName, 7, '..');
    var doctorWholeName = this.stringFactory(data.DoctorName);

    var feeReg = this.numberFeeFactory(data.FeeReg);

    var feeApartOpd = this.numberFeeFactory(data.APartOPD);
    var feeAPartDrug = this.numberFeeFactory(data.APartDrug);
    var ownFee = this.numberFeeFactory(data.AOwn);
    var deposit = this.numberFeeFactory(data.FeeLAMT);
    var aPartExam = this.numberFeeFactory(data.APartExam);
    var debt = this.numberFeeFactory(data.Debt);
    var repay = this.numberFeeFactory(data.Repay);

    var received = this.numberFeeFactory(data.Received);
    var feeTotal = this.numberFeeFactory(data.FeeTotal);
    var remark = this.stringLengthFactory(data.Remark, 30, '‥');
    // #17668: X5146 櫃台掛號的結帳報表->預覽列印 小計與說明欄位中間沒有空格,字會連一起
    // 增加空格於remark字串前面
    remark = '&ensp;' + remark;
    var remarkExcel = this.stringFactory(data.Remark);

    var paidCash = this.numberFeeFactory(data.PaidCash);
    var paidCreditCard = this.numberFeeFactory(data.PaidCreditCard);
    var paidCashCard = this.numberFeeFactory(data.PaidCashCard);
    var paidMedCard = this.numberFeeFactory(data.PaidMedCard);
    var paidTransfer = this.numberFeeFactory(data.PaidTransfer);
    var paidEPayment = this.numberFeeFactory(data.PaidEPayment);
    var paidOther = this.numberFeeFactory(data.PaidOther);
    var paidSum = this.numberFeeFactory(data.PaidSum);

    // Excel匯出時不加空行, 列印時才加
    var blankLine = (data.PatientNo === '總計' && !isForExcel)
      ? `<tr><td colspan="${this.columnLine}" class="rpt-blank-row"></td></tr>`
      : '';
    // 小計行: 列印時加分隔線tr,Excel時不加(改用td的border-bottom)
    var subLine = (data.PatientNo === '小計' && !isForExcel)
      ? `<tr>
          <td colspan="2" class="rpt-tr-spliter-padding"></td>
          <td colspan="${this.columnLine}" class="rpt-tr-spliter"></td>
        </tr>`
      : '';
    var isublinestyle: 'right' | 'left' = data.PatientNo === '小計' || data.PatientNo === '總計' ? 'right' : 'left';

    // Excel模式下,小計&總計行的td要加border-bottom
    var subCellStyle = ((data.PatientNo === '小計' || data.PatientNo === '總計') && isForExcel) ? 'border-bottom: 1.5px double black;' : '';
    var subCellStylePN = ((data.PatientNo === '小計' || data.PatientNo === '總計') && !isForExcel && this.queryRptType == 'summary') ? 'padding-right: 10px;' : '';
    // var jainfo = this.isInJail ?
    //       this.createColBlock2(patientCid, 'PatientCid', 'left', 0, true, subCellStyle)
    //     + this.createColBlock2(sptxExcel, 'Sptx', 'left', 0, true, subCellStyle) + this.createColBlock2(jaaddrExcel, 'JaAddr', 'left', 0, true, subCellStyle)
    //     + this.createColBlock2(japhoneExcel, 'JaPhone', 'left', 0, true, subCellStyle)
    //     : '';

    return blankLine + '<tr>'
      + this.createColBlock2(patientNo, 'PatientNo', 'left', -0.75, false, subCellStyle)
      + this.createColBlock2(patientName, 'PatientName', isublinestyle, 0, false, subCellStyle, subCellStylePN)
      + this.createColBlock2(visitSourceCode, 'VisitSourceCode', 'left', 0, false, subCellStyle)
      //+ this.createColBlock2(patientWholeName, 'PatientName', isublinestyle, 0, true, subCellStyle)
      + this.createColBlock2(date, 'Date', 'left', -0.75, false, subCellStyle)
      + this.createColBlock2(icdt, 'Icdt', 'left', 0, false, subCellStyle)
      + this.createColBlock2(icode, 'IcodeName', 'left', -0.25, false, subCellStyle)
      //+ jainfo
      + this.createColBlock2(icno, 'Isqno', 'left', 0, false, subCellStyle)
      + this.createColBlock2(timeSecName, 'TimeSecName', 'left', -0.25, false, subCellStyle)
      + this.createColBlock2(status, 'StatusWord', 'left', -0.25, false, subCellStyle)
      + this.createColBlock2(' ', 'DispTp', 'left', 0, false, subCellStyle)
      + this.createColBlock2(tp, 'SameTreat', 'left', 0, false, subCellStyle)
      + this.createColBlock2(' ', 'CusNo', 'left', 0, false, subCellStyle)
      + this.createColBlock(dutyCreater, 'DUTYCreater', 'left', -0.25, false, subCellStyle)
      //+ this.createColBlock(dutyCreaterWholeName, 'DUTYCreater', 'left', 0, true, subCellStyle)  //移除，會造成跑版
      + this.createColBlock2(roomCode, 'RoomCode', 'left', 0, false, subCellStyle)
      + this.createColBlock2(doctor, 'DoctorName', 'left', 0, false, subCellStyle)
      //+ this.createColBlock2(doctorWholeName, 'DoctorName', 'left', 0, true, subCellStyle)
      + this.createColBlock2(feeReg, 'FeeReg', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(feeApartOpd, 'APartOPD', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(ownFee, 'AOwn', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(deposit, 'FeeLAMT', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(feeAPartDrug, 'APartDrug', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(aPartExam, 'APartExam', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(debt, 'Debt', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(repay, 'Repay', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(received, 'Received', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(feeTotal, 'FeeTotal', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2('', 'space', 'right', 0, false, subCellStyle)
      + this.createColBlock2(remark, 'Remark', 'left', -0.25, false, subCellStyle)
      //+ this.createColBlock2(remarkExcel, 'Remark', 'left', 0, true, subCellStyle)
      + this.createColBlock2(paidCash, 'PaidCash', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(paidCreditCard, 'PaidCreditCard', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(paidCashCard, 'PaidCashCard', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(paidMedCard, 'PaidMedCard', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(paidTransfer, 'PaidTransfer', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(paidEPayment, 'PaidEPayment', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(paidOther, 'PaidOther', 'right', -0.75, false, subCellStyle)
      + this.createColBlock2(paidSum, 'PaidSum', 'right', -0.75, false, subCellStyle)
      + '</tr>'
      + subLine;
  }

  createColBlock2(value: string, tName: string, align: 'left' | 'right' | 'center', letterSpacing: 0 | -0.25 | -0.75 = 0, isExcel = false, extraStyle = '', extraStyle2 = '') {
    if (!this.allColumns.includes(tName) || this.hidecolArray.includes(tName)) return ''

    var da = DailyReportColEnum.find(x => x.Col == tName);
    if (da && da.Height > 1 && da.IsNeedHide == false && value) this.coladd = da.Height;

    var remark = (tName == 'Remark' || tName == 'PatientName' || tName == 'DUTYCreater' ||
      tName == 'DoctorName' || tName == 'PatientCid' || tName == 'Sptx' ||
      tName == 'JaAddr' || tName == 'JaPhone') ? isExcel ? 'excelver' : 'htmlver' : '';

    // 判斷是否需要強制文字格式的欄位
    var needTextFormat = (tName == 'PatientNo' || tName == 'Isqno' || tName == 'Remark');
    var excelFormat = needTextFormat ? "mso-number-format:'@';" : "";

    var noBorderBottom = !extraStyle;
    // 只在非Excel模式時強制border-bottom: none,Excel模式使用extraStyle
    var borderBottom = extraStyle ? extraStyle : '';
    var cls = `rpt-td alg-${align} ls-${letterSpacing == -0.75 ? 'l' : letterSpacing == -0.25 ? 's' : 'n'} ${noBorderBottom ? 'n-b-b' : ''}`
    var style = `${borderBottom}${excelFormat}${extraStyle2}`;

    return `<td ${remark} ${style ? `style="${style}"` : ''} class="excel-format-text ${cls}">${value}</td>`;
    //return `<td ${remark} ${excelFormat} style="text-align: ${align};letter-spacing: ${letterSpacing}pt;border-top: none;${borderBottom}" class="excel-format-text">${value}</td>`
  }
  createHTMLPageHeader(iPage, isSimpleVersion: boolean = false) {
    var clinicName = UserCache.getLoginUser().ClinicName;

    // 確保日期是 Date 物件
    const startDate = this._sDate ? new Date(this._sDate) : new Date();
    const endDate = this._eDate ? new Date(this._eDate) : new Date();

    // 共同標題內容
    const titleContent = `
        <tr>
            <td colspan="6" style="height: 30px; text-align: center; font-weight: bolder;font-family:標楷體; font-size: 17.5pt;font-weight: 600; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                ${clinicName}結帳報表
            </td>
        </tr>
        <tr>
            <td ${isSimpleVersion ? 'colspan="2"' : ''} style="font-family:標楷體;${isSimpleVersion ? '' : 'width: 30%; '}font-size: 15.5px;font-weight: 600; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
            印表時間：${DateHelper.getROCDateStringWithSepetator(DateHelper.today)}  ${this.onGetTimeString(new Date())}
            </td>
            <td ${isSimpleVersion ? 'colspan="2"' : ''} style="font-family:標楷體;${isSimpleVersion ? '' : 'width: 40%; '}font-size: 15.5px;font-weight: 600; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
            期間：${DateHelper.getROCDateStringWithSepetator(startDate)} 至 ${DateHelper.getROCDateStringWithSepetator(endDate)}
            </td>
            ${!isSimpleVersion ? `
            <td colspan="1" style="font-family:標楷體;width: 30%; font-size: 15.5px;font-weight: 600; text-align: right; border-right: none; border-left: none; border-bottom: none; border: none;">
            頁 ${(iPage + 1)}/<span id="totalPage-${iPage}"></span>
            </td>` : `
            <td colspan="2" style="font-family:標楷體;font-size: 15.5px;font-weight: 600; text-align: right; border-right: none; border-left: none; border-bottom: none; border: none;">
            </td>`}
        </tr>
        <tr>
            <td colspan="6" style="font-size: 15.5px;font-family:標楷體;font-weight: 600; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
            ${this.condStr}
            </td>
        </tr>
        ${isSimpleVersion ? '<tr><td colspan="6" style="height: 10px; border: none;"></td></tr>' : ''}
    `;

    // Excel 匯出：只回傳表格內容，不包含外層 div 結構
    if (isSimpleVersion) {
      return titleContent;
    }

    // 列印：包含完整的 div 結構
    return `<div id="header" style="margin: 0px 2px;">
            <div style="display: flex;column-gap: 5px;">
                <table style="width: 100%; border: none;">
                    ${titleContent}
                </table>
            </div>
          </div>
          <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px; text-align: center;">
            <label style="font-weight: bold; height: 23px;">　</label>
          </div>
          <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px;">
            <div style="display: flex;column-gap: 1px;">
            <table id="table-${iPage}-content" style="width: 100%;font-family:標楷體; font-size: ${this.fontsize}pt; border: none;">
            </table>
            </div>
          </div>`;
  }
  createHTMLPageHeader2(iPage) {
    var clinicName = UserCache.getLoginUser().ClinicName;

    // 確保日期是 Date 物件
    const startDate = this._sDate ? new Date(this._sDate) : new Date();
    const endDate = this._eDate ? new Date(this._eDate) : new Date();

    // 共同標題內容
    const titleContent = `
        <tr>
            <td colspan="6" class="rpt-title">
                ${clinicName}結帳報表
            </td>
        </tr>
        <tr>
            <td class="rpt-date">
            印表時間：${DateHelper.getROCDateStringWithSepetator(DateHelper.today)}  ${this.onGetTimeString(new Date())}
            </td>
            <td class="rpt-region">
            期間：${DateHelper.getROCDateStringWithSepetator(startDate)} 至 ${DateHelper.getROCDateStringWithSepetator(endDate)}
            </td>
            <td colspan="1" class="rpt-page-no">
            頁 ${(iPage + 1)}/<span id="totalPage-${iPage}">{{totalPage-${iPage}}}</span>
            </td>
        </tr>
        <tr>
            <td colspan="6" class="rpt-filter">
            ${this.condStr}
            </td>
        </tr>
        `;
    // 列印：包含完整的 div 結構

    //line-height: 20px 設定限高度為定20px,table-layout: fixed寬度不要超出邊界
    return `
        <style>
          .rpt-table-container > div > table {
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
            word-break: break-word;
          }
          .rpt-table-container > div > table td,
          .rpt-table-container > div > table th {
          line-height: 20px;
          }
    </style>

    <div class="rpt-page-header" id="header">
      <div>
        <table>
          ${titleContent}
        </table>
      </div>
    </div>
    <div class="rpt-table-gap">
      <label>　</label>
    </div>
    <div class="rpt-table-container">
      <div>
        <table id="table-${iPage}-content">{{table-${iPage}-content}}</table>
      </div>
    </div>`;
  }

  createHTMLPageFirstSumHeader(iPage) {
    return `<br />
            <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;zoom: 0.8;margin: 0px 2px;">
                <div style="display: flex;column-gap: 1px;">
                    <table id="table-` + iPage + `-sum" style="width: 100%;font-family:標楷體; font-size: ${this.fontsize}pt; border: none;">
                    </table>
                </div>
            </div>`;
  }
  createHTMLPageFirstSumHeader2(iPage) {
    return `<br />
            <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;zoom: 0.8;margin: 0px 2px;">
                <div style="display: flex;column-gap: 1px;">
                    <table id="table-` + iPage + `-sum" style="width: 100%;font-family:標楷體; font-size: ${this.fontsize}pt; border: none;">
                    {{table-${iPage}-sum}}
                    </table>
                </div>
            </div>`;
  }

  createHTMLPageSumHeader(iPage) {
    var clinicName = UserCache.getLoginUser().ClinicName;

    // 確保日期是 Date 物件
    const startDate = this._sDate ? new Date(this._sDate) : new Date();
    const endDate = this._eDate ? new Date(this._eDate) : new Date();

    return `<div id="header" style="margin: 0px 2px;">
                <div style="display: flex;column-gap: 5px;">
                    <table style="width: 100%; border: none;">
                        <tr>
                            <td colspan="6" style="height: 30px; text-align: center; font-weight: bolder;font-family:標楷體; font-size: 17.5pt;font-weight: 600; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                ${clinicName}結帳報表
                            </td>
                        </tr>
                        <tr>
                            <td style="font-family:標楷體;width: 30%; font-size: 15.5px;font-weight: 600; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                            印表時間： ${DateHelper.getROCDateStringWithSepetator(DateHelper.today)} ${this.onGetTimeString(new Date())}
                            </td>
                            <td style="font-family:標楷體;width: 40%; font-size: 15.5px;font-weight: 600; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                            期間：${DateHelper.getROCDateStringWithSepetator(startDate)} 至 ${DateHelper.getROCDateStringWithSepetator(endDate)}
                            </td>
                            <td style="font-family:標楷體;width: 30%; font-size: 15.5px;font-weight: 600; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                            頁 ${(iPage + 1)}/<span id="totalPage-${iPage}"></span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px; text-align: center;">
                <label style="font-weight: bold; height: 23px;">　</label>
            </div>
            <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px;">
                <div style="display: flex;column-gap: 1px;">
                    <table id="table-${iPage}-sum" style="width: 100%;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600; border: none;">
                    </table>
                </div>
            </div>`;
  }
  createHTMLPageSumHeader2(iPage) {
    var clinicName = UserCache.getLoginUser().ClinicName;

    // 確保日期是 Date 物件
    const startDate = this._sDate ? new Date(this._sDate) : new Date();
    const endDate = this._eDate ? new Date(this._eDate) : new Date();

    return `<div id="header" style="margin: 0px 2px;">
                <div style="display: flex;column-gap: 5px;">
                    <table style="width: 100%; border: none;">
                        <tr>
                            <td colspan="6" style="height: 30px; text-align: center; font-weight: bolder;font-family:標楷體; font-size: 17.5pt;font-weight: 600; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                ${clinicName}結帳報表
                            </td>
                        </tr>
                        <tr>
                            <td style="font-family:標楷體;width: 30%; font-size: 15.5px;font-weight: 600; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                            印表時間： ${DateHelper.getROCDateStringWithSepetator(DateHelper.today)} ${this.onGetTimeString(new Date())}
                            </td>
                            <td style="font-family:標楷體;width: 40%; font-size: 15.5px;font-weight: 600; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                            期間：${DateHelper.getROCDateStringWithSepetator(startDate)} 至 ${DateHelper.getROCDateStringWithSepetator(endDate)}
                            </td>
                            <td style="font-family:標楷體;width: 30%; font-size: 15.5px;font-weight: 600; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                            頁 ${(iPage + 1)}/<span id="totalPage-${iPage}">{{totalPage-${iPage}}}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px; text-align: center;">
                <label style="font-weight: bold; height: 23px;">　</label>
            </div>
            <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px;">
                <div style="display: flex;column-gap: 1px;">
                    <table id="table-${iPage}-sum" style="width: 100%;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600; border: none;">
                    {{table-${iPage}-sum}}
                    </table>
                </div>
            </div>`;
  }
  createHTMLPageNoHeader(iPage) {
    return `<div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px; text-align: center;">
            <label style="font-weight: bold; height: 23px;">　</label>
            </div>
            <div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px;">
                <div style="display: flex;column-gap: 1px;">
                    <table id="table-` + iPage + `-content" style="width: 100%;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600; border: none;">
                    </table>
                </div>
            </div>`;
  }
  createHTMLFinish() {
    return `<div style="-webkit-text-size-adjust: none;font-family:標楷體; font-size: ${this.fontsize}pt;font-weight: 600;zoom: 0.8;margin: 0px 2px; text-align: center; border-top: 5px double black;padding-top: 5px">
                <label style="font-weight: bold;">以下空白</label>
            </div>`;
  }

  getHtml() {
    var html = this.reportContainer.nativeElement.innerHTML;
    return html;
  }

  async onPrint() {
    if (this.listItems) {
      var reportName = '結帳報表';
      const printContents = this.getHtml();
      var ret = await this.localPrintService.printHtml(888, '結帳報表', printContents);
      if (ret.Successed) {
        this.notification.showSuccess(reportName + '已送出列印!', true);
      } else {
        this.notification.showError(reportName + '送出列印失敗!');
      }
    } else {
      this.notification.showInfo('查無資料可供列印!');
    }
  }

  async exportAsExcel() {
    if (this.listItems) {
      var reportName = '結帳報表';

      let visibleColumnCount = 0;
      const testHeader = this.createHTMLListHeader(true);
      const thMatches = testHeader.match(/<th[^>]*>/g);
      if (thMatches) {
        visibleColumnCount = thMatches.length;
      }

      if (visibleColumnCount === 0) {
        visibleColumnCount = 30;
      }

      // 使用與列印相同的表頭格式
      // 傳入 isSimpleVersion: true 來取得簡化版(不含外層div)
      let headerHtml = this.createHTMLPageHeader(0, true);

      // 調整colspan以符合實際欄位數
      headerHtml = headerHtml.replace(/colspan="6"/g, `colspan="${visibleColumnCount}"`);
      headerHtml = headerHtml.replace(/colspan="2"/g, `colspan="${Math.floor(visibleColumnCount * 0.35)}"`);

      let completeTableHtml = headerHtml;

      // 後續的欄位標題和資料處理
      let listHeaderHtml = this.createHTMLListHeader(true);
      listHeaderHtml = listHeaderHtml.replace(/<th[^>]*\bhtmlver\b[^>]*>[\s\S]*?<\/th>/gi, '');
      listHeaderHtml = listHeaderHtml.replace(/font-size:\s*[\d.]+pt/gi, 'font-size: 12pt; font-family: 標楷體');
      completeTableHtml += listHeaderHtml;

      for (let i = 0; i < this.listItems.length; i++) {
        let blockHtml = this.createHTMLBlock(this.listItems[i], true);
        blockHtml = blockHtml.replace(/<td[^>]*\bhtmlver\b[^>]*>[\s\S]*?<\/td>/gi, '');
        blockHtml = blockHtml.replace(/(<td[^>]*style="[^"]*)(")/gi, '$1; font-size: 12pt; font-family: 標楷體$2');
        completeTableHtml += blockHtml;
      }

      if (this.listIcodeSum.length > 0) {
        completeTableHtml += '<tr><td colspan="' + visibleColumnCount + '" style="height: 20px; border: none;"></td></tr>';

        let sumHeaderHtml = this.createSumListHeader();
        sumHeaderHtml = sumHeaderHtml.replace(/(<th[^>]*style="[^"]*)(")/gi, '$1; font-size: 12pt; font-family: 標楷體$2');
        completeTableHtml += sumHeaderHtml;

        for (let i = 0; i < this.listIcodeSum.length; i++) {
          let sumBlockHtml = this.createSumBlock(this.listIcodeSum[i]);
          sumBlockHtml = sumBlockHtml.replace(/(<td[^>]*style="[^"]*)(")/gi, '$1; font-size: 12pt; font-family: 標楷體$2');
          completeTableHtml += sumBlockHtml;
        }
      }

      await this.hcrService.ExportTableToExcel(reportName, completeTableHtml, true, true);
    } else {
      this.notification.showInfo('查無資料可供匯出!');
    }
  }

  /** 轉換Date To String
   *  [參數] ev:值，isRoc:是否轉換成民國年，symbol:分隔符號，isMonth:是否只顯示到月份
   */
  onGetDateString(ev, isRoc: boolean = false, symbol = '/', isMonth = false) {
    if (ev) {
      var d = new Date(ev);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = isRoc ? (d.getFullYear() - 1911) : d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      if (isMonth) {
        return [year, month].join(symbol);
      } else {
        return [year, month, day].join(symbol);
      }
    }
  }

  /** 轉換Time To String
      *  [參數] ev:值，isRoc:是否轉換成民國年，symbol:分隔符號，isMonth:是否只顯示到月份
  */
  onGetTimeString(ev, timeSymbol = ':') {
    if (ev) {
      var d = new Date(ev);
      // 趕時間先簡單寫
      let hr = d.getHours().toString();
      if (d.getHours() < 10) {
        hr = '0' + hr;
      }
      let min = d.getMinutes().toString();
      if (d.getMinutes() < 10) {
        min = '0' + min;
      }
      let sec = d.getSeconds().toString();
      if (d.getSeconds() < 10) {
        sec = '0' + sec;
      }
      var timeStr = [hr, min, sec].join(timeSymbol);
      return timeStr;
    }
  }

  onGetDate(ev) {
    if (ev) {
      var d = new Date(ev);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [month, day].join('');
    }
  }
}

export interface DailyReportPrintParaMeter {
  Type: number;
  PaperSize: string;
  AdjustHeight: number;
  PagePaddingTop: number;
  PagePaddingBottom: number;
  PagePaddingRight: number;
  PagePaddingLeft: number;
  PageHeight: number;
  PageWidth: number;
  InitFontSize: number;
  InitRow: number;
}
